import type { ReactNode } from "react";
import ButtonBase from "@mui/material/ButtonBase";

// A PRIMENG `p-tabView` WITH THE PILLARS OVERRIDES (`_overrides.scss`): A 1PX
// `--surface-border` RULE UNDER THE NAV; EACH TAB IS 0.75REM 1REM, WEIGHT 600, UPPERCASE AT
// `font-size: smaller`, `--gray-500`; THE ACTIVE TAB IS PRIMARY AND "LIFTED" - BORDERED ON
// THREE SIDES WITH ITS BOTTOM EDGE IN THE CARD COLOR, SITTING 1PX OVER THE RULE. PANELS
// HAVE NO PADDING. `[scrollable]` BECOMES A HORIZONTALLY SCROLLING NAV; PRIMENG'S PREV /
// NEXT ARROW BUTTONS ARE NOT REPRODUCED.
export function PTabView<T>(props: {
  tabs: T[];
  active: number;
  onChange: (index: number) => void;
  label: (tab: T) => string;
  className?: string;
  children: ReactNode;
}) {
  const { tabs, active, onChange, label, className, children } = props;
  return (
    <div className={className}>
      <div style={{ overflowX: "auto", overflowY: "hidden", scrollbarWidth: "none" }}>
        <ul
          role="tablist"
          style={{
            display: "flex",
            margin: 0,
            padding: 0,
            listStyle: "none",
            borderBottom: "1px solid var(--surface-border)",
          }}
        >
          {tabs.map((t, i) => {
            const on = i === active;
            return (
              <li key={i} style={{ flex: "none" }}>
                <ButtonBase
                  role="tab"
                  aria-selected={on}
                  disableRipple
                  onClick={() => onChange(i)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    fontFamily: "inherit",
                    fontSize: "smaller",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    lineHeight: "normal",
                    padding: "0.75rem 1rem",
                    marginBottom: "-1px",
                    border: "1px solid",
                    borderColor: on
                      ? "var(--surface-border) var(--surface-border) var(--surface-card) var(--surface-border)"
                      : "var(--surface-card) var(--surface-card) var(--surface-border) var(--surface-card)",
                    borderRadius: "4px 4px 0 0",
                    backgroundColor: "var(--surface-card)",
                    color: on ? "var(--primary-color)" : "var(--gray-500)",
                    "&:hover": on ? undefined : { borderColor: "var(--surface-border)" },
                  }}
                >
                  {label(t)}
                </ButtonBase>
              </li>
            );
          })}
        </ul>
      </div>
      <div role="tabpanel">{children}</div>
    </div>
  );
}
